// @ts-nocheck

import { uniq, slice } from 'lodash';

import { type StateType } from '../../../states';
import Grid from '../states/grid';
import Pool from '../states/pool';
import Selection from '../states/selection';
import type { SystemGridWithAmount } from '../types';

import { getGrid } from './grids';
import { getPool } from './pool';

export const getAuthor = (
  state: StateType,
  {
    gridReference,
    isBasket = false,
    noDate = false,
  }: { gridReference: string; isPublicGrid: boolean; isBasket: boolean; noDate: boolean },
) => {
  let nickname = null;
  let avatarPath = null;
  let gridAmount = null;
  let fundingAmount = null;
  let contributorsCount = null;
  let winnings = null;
  let gridDate = null;
  let gridLength = null;
  let badges = [];

  const grid = getGrid(state, gridReference);
  if (grid) {
    const { poolId, betslips, allBetAmount, author } = grid;
    const contributors = uniq(betslips?.map((betslip) => betslip.nickname));

    gridAmount = Grid.getAmount(grid);
    fundingAmount = allBetAmount;
    contributorsCount = contributors.length;
    nickname = author?.nickname;
    avatarPath = author?.avatarPath;

    const pool = getPool(state, poolId);
    const type = Pool.getType(poolId);
    badges = Grid.getBestAuthorBadge(grid, type);

    if (!isBasket) {
      gridDate = !noDate && Grid.getDate(grid);
      gridLength = pool?.nbMatches;
      winnings = (gridLength && author?.winnings && (author?.winnings || {})[gridLength]) || null;
    }
  }

  return {
    nickname,
    avatarPath,
    gridAmount,
    fundingAmount,
    contributorsCount,
    winnings,
    gridDate,
    gridLength,
    badges: badges ? [badges] : [],
  };
};

export const getSystemGridWithAmount = (selection: string, index: number): SystemGridWithAmount => {
  const amount = Selection.getAmount(selection);
  const selectionIndex = index + 1;
  return {
    selection,
    amount,
    selectionIndex,
  };
};

export const getSystemList = (
  state: StateType,
  { poolId, gridReference, isPublicGrid }: { poolId?: number; gridReference?: string; isPublicGrid?: boolean },
) => {
  let grids = [];
  let finalPoolId = poolId;

  if (isPublicGrid && gridReference) {
    const grid = getGrid(state, gridReference);
    finalPoolId = grid?.poolId;
    grids = grid?.systemStrGridSelections?.map<SystemGridWithAmount>(getSystemGridWithAmount);
  } else {
    const { basket } = state.grids;
    const { selections, isSystem } = basket;
    const systemSelections = slice(selections, 1, selections.length);
    if (isSystem) {
      grids = systemSelections.map<SystemGridWithAmount>(getSystemGridWithAmount);
    }
  }

  return {
    grids,
    poolId: finalPoolId,
    isReadOnly: isPublicGrid,
  };
};
